// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
//import mock from './mock/mock'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import scroll from 'vue-seamless-scroll'
import 'animate.css';
import wow from 'wowjs'
import "wowjs/css/libs/animate.css"
Vue.prototype.$wow = wow

Vue.config.productionTip = false

process.env.MOCK && require("./mock/mock.js")


Vue.use(scroll)
// Vue.use(ElementUI)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js